import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../core/form/Button';
import { browserHistory } from 'react-router';
import Separator from '../../../../core/layout/Separator';
import Card from '../../../../core/layout/Card';

const UnitItemHistoryDetail = (props) => (
  <Card
    title="Item details"
    loading={props.fetching}
    actions={<Button icon="arrow-left" label="Back" onClick={() => browserHistory.goBack()} />}
  >
    <div>
      <strong>Order</strong>
      <span>: {props.unitItem.order}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <strong>Group</strong>
      <span>: {['', 'Default', 'First Review', 'Second Review'][props.unitItem.group]}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <strong>Item type</strong>
      <span>: {props.unitItem.item.type.name}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <strong>Text</strong>
      <span>: {props.unitItem.item.text}</span>
    </div>
  </Card>
);

UnitItemHistoryDetail.propTypes = {
  fetching: PropTypes.bool,
  unitItem: PropTypes.shape({
    order: PropTypes.number.isRequired,
    group: PropTypes.number.isRequired,
    item: PropTypes.shape({
      text: PropTypes.string.isRequired,
      type: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

UnitItemHistoryDetail.defaultProps = {
  fetching: false,
};

export default UnitItemHistoryDetail;
